<template>
  <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" max-width="640">
    <v-btn icon @click="$emit('toggleDialog')" absolute top right>
      <v-icon color="white">{{ "close" }}</v-icon>
    </v-btn>
    <v-card style="overflow: hidden;">
      <v-container class="pa-0">
        <v-row
          align="center"
          justify="center"
        >
          <video id="video" playsinline controls>
            <source :src="received.video" type="video/webm">
          </video>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

  import Plyr from 'plyr'
  
  export default {
    name: 'VideoDialog',
    props: ['dialog', 'received'],
    data: () => ({
      player: null
    }),
    mounted() {
      this.player = new Plyr('#video')
    }
  }

</script>

<style lang="scss">
  @import '../../node_modules/plyr/dist/plyr.css';

  .plyr {
    max-width: 640px !important;
    width: 100%;
    max-height: 360px;
    height: 100%;
    vertical-align: top;
  }
</style>